import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  ToolTip,
  useFormHandler,
} from "../../../../../../components";
import {
  cityStateListOptions,
  countryListOptions,
} from "../../../../../../assets/data/projectData";
import { WorkLocationType } from "../../../../../../assets/data/enumData";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { addNewPlacementStart } from "../../../../../../redux/slices/placements/placementsSlice";
import { useDispatch } from "react-redux";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";

const WorkLocation = ({
  setActiveTab,
  onCancel,
  currentPlacement,
  handleBack,
  editData,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields, setErrors } =
    useFormHandler(
      {
        // markMandatory: false,
        country: "",
        workLocationType: "",
        workEmail: "",
        workPhoneNumber: "",
        countryCode: "",
        addressLineOne: "",
        addressLineTwo: "",
        city: "",
        state: "",
        zipCode: "",
        amendmentRequired: false,
        stateandCountry: [],
      },
      {
        // markMandatory: { type: "toggle", required: true },
        // country: { type: "select", required: true },
        // workLocationType: { type: "select", required: true },
        // workEmail: { type: "email", required: true },
        // workPhoneNumber: { type: "phone", required: true },
        // addressLineOne: { type: "text", required: true },
        // addressLineTwo: { type: "text", required: true },
        // city: { type: "select", required: true },
        // state: { type: "select", required: true },
        // zipCode: { type: "text", required: true },
        // amendmentRequired: { type: "toggle", required: true },
        // stateandCountry: { type: "checkbox", required: true },
      },
    );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const workLocation = {
        // mandatory: formData?.markMandatory,
        type: formData?.workLocationType,
        workEmail: formData?.workEmail,
        address: {
          country: formData?.country?.value ?? formData?.country,
          state: formData?.state?.value ?? formData?.state,
          city: formData?.city?.value ?? formData?.city,
          zipCode: formData?.zipCode,
          address1: formData?.addressLineOne,
          address2: formData?.addressLineTwo,
        },
        phone: {
          code: formData?.countryCode,
          number: formData?.workPhoneNumber,
        },
        amendment: formData?.amendmentRequired,
        showInGeneral: formData?.stateandCountry ? true : false,
      };
      const submissionData = filterEmptyValues(workLocation);
      const uiid = fetchPerticularData?.uiid ?? "";
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "clientPlacementWorkLocation",
          payload: [
            {
              type: "SET",
              value: {
                clientPlacement: {
                  workLocation: {
                    ...submissionData,
                  },
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            handleBack();
          },
        }),
      );
    } else {
      console.log(
        "please fill the required feilds before you submitting  : ",
        errors,
      );
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "clientPlacement.workLocation uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          console.log("data", data);
          const workLocation = data?.clientPlacement?.workLocation || {};
          setFetchPerticularData(data);
          // handleChange("markMandatory",workLocation?.mandatory)
          handleChange("workLocationType", workLocation?.type);
          handleChange("workEmail", workLocation?.workEmail);
          handleChange("country", workLocation?.address?.country);
          handleChange("state", workLocation?.address?.state);
          handleChange("city", workLocation?.address?.city);
          handleChange("zipCode", workLocation?.address?.zipCode);
          handleChange("addressLineOne", workLocation?.address?.address1);
          handleChange("addressLineTwo", workLocation?.address?.address2);
          handleChange("countryCode", workLocation?.phone?.code);
          handleChange("workPhoneNumber", workLocation?.phone?.number);
          handleChange("amendmentRequired", workLocation?.amendment);
          handleChange(
            "stateandCountry",
            workLocation?.showInGeneral === true ? ["1"] : false,
          );
        }
      } catch (error) {
        setFetchPerticularData(null);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="px-8 py-5 border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="px-8 py-5 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6 ">
        {/* <div className="col-span-1">
          <FormFieldSet
            type="toggle"
            title={
              <ToolTip size="sm" description={"hhh"} tooltipPosition="left">
                <span className="mr-1">Mark Mandatory</span>
              </ToolTip>
            }
            isChecked={formData?.markMandatory}
            value={formData?.markMandatory}
            onChange={() =>
              handleChange("markMandatory", !formData.markMandatory)
            }
            error={errors.markMandatory}
          />
        </div> */}
        <div className="col-span-1">
          <FormFieldSet
            type="select"
            title={"Work Location Type"}
            placeholder="Select Work Location Type"
            value={formData.workLocationType}
            onChange={(value) => handleChange("workLocationType", value)}
            error={errors.workLocationType}
            options={WorkLocationType}
          />
        </div>
        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Work Email"}
            placeholder="Enter Work Email"
            value={formData.workEmail}
            onChange={(value) => handleChange("workEmail", value)}
            error={errors.workEmail}
          />
        </div>
        <div className="col-span-1">
          {/* <FormFieldSet
            type="phone"
            title={"Work Phone Number"}
            placeholder="Enter Work Phone Number"
            value={formData.workPhoneNumber}
            onChange={(value) => handleChange("workPhoneNumber", value)}
            error={errors.workPhoneNumber}
          /> */}
          <FormFieldSet
            type="phone"
            title={"Work Phone Number"}
            placeholder="Enter Work Phone Number"
            value={formData.workPhoneNumber?.toString() || ""}
            onChange={(fullValue, details) => {
              handleChange("workPhoneNumber", details.number.toString());
              handleChange("countryCode", details.countryCode);
              setErrors({
                ...errors,
                workPhoneNumber: details.number
                  ? details?.error?.valid === true
                    ? ""
                    : "Mobile number invalid"
                  : "",
              });
            }}
            error={errors.workPhoneNumber}
          />
        </div>

        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Address Line 1"}
            placeholder="Enter Address Line 1"
            value={formData.addressLineOne}
            onChange={(value) => handleChange("addressLineOne", value)}
            error={errors.addressLineOne}
          />
        </div>
        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Address Line 2"}
            placeholder="Enter Address Line 2"
            value={formData.addressLineTwo}
            onChange={(value) => handleChange("addressLineTwo", value)}
            error={errors.addressLineTwo}
          />
        </div>

        <div className="col-span-1">
          {/* <FormFieldSet
            type="select"
            title={"Country"}
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            error={errors.country}
            options={countryListOptions}
          /> */}
          <FormFieldSet
            type="countriesUsAndCanada"
            title="Country"
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            error={errors.country}
            options={countryListOptions}
          />
        </div>
        <div className="col-span-1">
          {/* <FormFieldSet
            type="select"
            title={"State"}
            placeholder="Select State"
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            error={errors.state}
            options={cityStateListOptions}
          /> */}
          <FormFieldSet
            type="states"
            title="State"
            placeholder="Select State"
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            error={errors.state}
            disabled={!formData.country}
            parentValue={{
              country: formData?.country?.value ?? formData?.country,
            }}
            showSearch
          />
        </div>
        <div className="col-span-1">
          {/* <FormFieldSet
            type="text"
            title={"City"}
            placeholder="Enter City"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
          /> */}
          <FormFieldSet
            type="cities"
            title="City"
            placeholder="Select City"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
            disabled={!formData.state}
            parentValue={{
              country: formData?.country?.value ?? formData?.country,
              state: formData?.state?.value ?? formData?.state,
            }}
            showSearch
          />
        </div>

        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Zip Code"}
            placeholder="Enter Zip Code"
            value={formData.zipCode}
            onChange={(value) => handleChange("zipCode", value)}
            error={errors.zipCode}
          />
        </div>

        <div className="col-span-1">
          <FormFieldSet
            type="toggle"
            title={"Amendment Required"}
            isChecked={formData?.amendmentRequired}
            value={formData?.amendmentRequired}
            onChange={() =>
              handleChange("amendmentRequired", !formData.amendmentRequired)
            }
            error={errors.amendmentRequired}
          />
        </div>
      </div>
      <div className="mt-6">
        <FormFieldSet
          type="checkbox"
          title={
            // "Display State and Country of this address under Location in General tab."
            ""
          }
          options={[
            {
              label:
                "Display State and Country of this address under Location in General tab.",
              value: "1",
            },
          ]}
          values={formData.stateandCountry || []}
          onChange={(value) => handleChange("stateandCountry", value)}
          multiple
          error={errors.stateandCountry}
        />
      </div>
      <div className="flex gap-3 justify-end mt-3">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={() => handleCancel()}
        />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default WorkLocation;
